import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b14434c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "voc-container" }
const _hoisted_2 = {
  class: "voc-list",
  ref: "listContainer",
  role: "main"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  role: "list",
  "aria-label": "문의글 목록"
}
const _hoisted_5 = ["href", "onClick", "onKeydown", "aria-label"]
const _hoisted_6 = {
  key: 1,
  class: "no-result"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  id: "no-results",
  role: "status",
  "aria-live": "polite"
}, " 검색 결과가 없습니다. ", -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  class: "modal-content",
  id: "limit-message"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "문의하기" }),
        _createVNode($setup["SearchInput"], {
          class: "search",
          name: "문의하기",
          placeholder: "문의할 내용을 검색하세요",
          value: $setup.searchKeyword,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchKeyword) = $event)),
          delayMilliSeconds: 0,
          "aria-label": "문의 내용 검색",
          onOnEnter: $setup.searchVoc,
          onClearText: $setup.clearSearchKeyword
        }, null, 8 /* PROPS */, ["value"]),
        _createVNode($setup["CheckboxInput"], {
          class: "my-post-checkbox",
          title: "내 글 보기",
          value: $setup.shouldShowOnlyMyPost,
          onOnChangedCheck: $setup.handleClickShowOnlyMyPostCheckBox
        }, null, 8 /* PROPS */, ["value"]),
        _createCommentVNode(" 문의하기 글 목록 "),
        _createElementVNode("main", _hoisted_2, [
          (!!$setup.vocList.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                _createElementVNode("ul", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vocList, (voc) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: voc.uid,
                      role: "listitem"
                    }, [
                      _createVNode(_component_router_link, {
                        to: {
                  name: $setup.RouterName.VocDetail,
                  params: { uid: voc.uid },
                },
                        custom: ""
                      }, {
                        default: _withCtx(({ navigate, href }) => [
                          _createElementVNode("a", {
                            href: href,
                            onClick: _withModifiers(() => $setup.goToVocDetail(voc, navigate), ["prevent"]),
                            onKeydown: _withKeys(_withModifiers(() => $setup.goToVocDetail(voc, navigate), ["prevent"]), ["enter"]),
                            class: "voc-info-link",
                            "aria-label": `문의글: ${voc.title}`
                          }, [
                            _createVNode($setup["VocRow"], { voc: voc }, null, 8 /* PROPS */, ["voc"])
                          ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_5)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_6, [..._hoisted_8]))
        ], 512 /* NEED_PATCH */),
        ($setup.listContainer)
          ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
              key: 0,
              container: $setup.listContainer,
              class: "scroll-top-btn"
            }, null, 8 /* PROPS */, ["container"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("button", {
          class: "btn-apply",
          type: "button",
          "aria-label": "새 문의 작성하기",
          onClick: $setup.onClickVocBtn
        }, " 문의하기 ")
      ]),
      ($setup.shouldShowDailyWritingCountLimitModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 0,
            title: "작성 횟수 초과",
            okButtonTitle: "확인",
            role: "alertdialog",
            "aria-describedby": "limit-message",
            onOnClickOkButton: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowDailyWritingCountLimitModal(false)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_9, [
                _createTextVNode(" 하루에 최대 " + _toDisplayString($setup.maxDailyVocCreationCount ?? "-") + "개의 게시물만 작성할 수 있습니다.", 1 /* TEXT */),
                _hoisted_10,
                _createTextVNode(" 내일 다시 시도해 주세요. ")
              ])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}